const isFormattedImage = (image: string) =>
  image.startsWith('data:image') ||
  image.endsWith('jpg') ||
  image.endsWith('png') ||
  image.endsWith('jpeg');
export default isFormattedImage;
